export const locale = {
    lang: 'en',
    data: {
      DATE_RANGE: {
        FROM: 'From',
        TO: 'To',
        PERIOD: 'Period',
        CURRENT_MONTH: 'Current Month',
        PREVIOUS_MONTH: 'Previous Month',
        CURRENT_YEAR: 'Current Year',
        PREVIOUS_YEAR: 'Previous Year',
        FLOATING_MONTH: 'Last 30 Days',
        FLOATING_YEAR: 'Last 365 Days',
        RESET: 'Reset to Current Month',
        CLEAR_FILTER: 'Clear Filter',
        APPLY_FILTER: 'Apply Filter'
      }
    }
  };